import { gql } from "@apollo/client";

export const GET_INTERVENTIONS_BY_MACHINE = gql`
	query InterventionsByMachine($id: String!) {
		interventionsByMachine(id: $id) {
			_id
			technicianId
			startedAt
			type
			obs
			photosTaken
			createdAt
			technicianInfo {
				name
			}
		}
	}
`;
